import { render, staticRenderFns } from "./WithdrawRecord.vue?vue&type=template&id=520d0612&scoped=true&"
import script from "./WithdrawRecord.vue?vue&type=script&lang=js&"
export * from "./WithdrawRecord.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawRecord.vue?vue&type=style&index=0&id=520d0612&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520d0612",
  null
  
)

export default component.exports